module.exports = __webpack_public_path__ + "static/media/sourcing_cv_i.d876731b.jpeg";